import cn from 'classnames';
import React from 'react';
import styles from './markdown.module.css';

interface PropTypes {
  className?: string;
}

const Markdown: React.FC<React.PropsWithChildren<PropTypes>> = ({
  children,
  className,
}) => {
  return (
    <div
      className={cn('font-sans text-text-secondary', styles.root, className)}
    >
      {children}
    </div>
  );
};

export default Markdown;
